
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 22.442c-2.5.521-4.06-1.979-4.06-1.979a4.4 4.4 0 01-3.621 2.055 4.606 4.606 0 01-3.619-2.055 4.4 4.4 0 01-3.62 2.055 4.599 4.599 0 01-3.62-2.055S2.952 23 .5 22.483m23-4.041c-2.5.521-4.06-1.979-4.06-1.979a4.4 4.4 0 01-3.621 2.055 4.606 4.606 0 01-3.619-2.055 4.4 4.4 0 01-3.62 2.055 4.599 4.599 0 01-3.62-2.055S2.952 19 .5 18.483M9 15.727V3.947a2.5 2.5 0 115 0v1m2 10.995V3.947a2.5 2.5 0 014.268-1.768A2.5 2.5 0 0121 3.947v1m-12.002 5.5h7m-7-3h7m-7 6h7","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    